<template>
  <CRow class="material border pl-1 pr-3 py-1 mx-0 full-repeater-row" :id="randomId">
    <CCol class="col-10">
      <CRow>
        <CCol class="mt-2" sm="2">
          <MaterialText v-model="localMaterial.stueckzahl" placeholder="Stück" form-label="Stück*" />
        </CCol>
        <CCol class="mt-2" sm="3">
          <MaterialText rules="" v-model="localMaterial.artikelnr" placeholder="Artikel Nr." label="Art.-Nr." />
        </CCol>
        <CCol class="mt-2" sm="6">
          <MaterialText rules="" v-model="localMaterial.material" placeholder="Material" label="Material" />
        </CCol>
      </CRow>
      <CRow v-if="isQuantitySuggestionsVisible && visibleQuantitySuggestions.length > 0">
        <CCol sm="12" class="mt-2">
          <div class="qty-suggestions-row">
            <CButton
              v-for="qty in visibleQuantitySuggestions"
              :key="`qty-${randomId}-${qty}`"
              color="secondary"
              variant="outline"
              size="sm"
              class="qty-suggestion-button"
              @click="applyQuantitySuggestion(qty)"
            >
              {{ formatQuantitySuggestionLabel(qty) }}
            </CButton>
          </div>
        </CCol>
      </CRow>
    </CCol>
    <CCol class="col-2 mt-2 text-right m-auto center">
      <CButton
        color="danger"
        variant="outline"
        size="sm"
        class="center m-auto center vertical-middle"
        v-c-tooltip="{content: 'Löschen', placement:'left'}"
        v-on:click="deleteEntry(randomId)">
        <CIcon name="cil-trash"/>
      </CButton>
    </CCol>
  </CRow>
</template>

<script>
import MaterialText from '@/components/FormElements/Text'

export default {
  name: 'formular-material',
  components: {
    MaterialText
  },
  props: {
    value: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      randomId: 'repeater-row-material-' + this.getRandomInt(10000)
    }
  },
  computed: {
    isQuantitySuggestionsVisible () {
      return process.env.VUE_APP_ENABLE_PROTOKOLL_MATERIAL_QTY_SUGGESTIONS !== 'false'
    },
    quantitySuggestions () {
      if (!this.localMaterial) {
        return []
      }

      const primarySuggestions = Array.isArray(this.localMaterial.qtySuggestions) ? this.localMaterial.qtySuggestions : []
      const recentSuggestions = Array.isArray(this.localMaterial.recentQtySuggestions) ? this.localMaterial.recentQtySuggestions : []
      const seenSuggestions = {}

      return primarySuggestions.concat(recentSuggestions).filter((value) => {
        const normalizedValue = String(value || '').trim()
        if (normalizedValue === '' || seenSuggestions[normalizedValue]) {
          return false
        }

        seenSuggestions[normalizedValue] = true
        return true
      })
    },
    visibleQuantitySuggestions () {
      return this.quantitySuggestions.slice(0, 6)
    },
    localMaterial: {
      get () {
        if (!this.value) {
          return {}
        }

        return this.value
      },
      set (localMaterial) { localMaterial.uid = this.randomId; this.$emit('input', localMaterial) }
    }
  },
  methods: {
    applyQuantitySuggestion (quantity) {
      const nextMaterial = Object.assign({}, this.localMaterial)
      nextMaterial.stueckzahl = this.formatQuantitySuggestionLabel(quantity)
      this.localMaterial = nextMaterial
    },
    formatQuantitySuggestionLabel (quantity) {
      const normalizedQuantity = String(quantity || '').trim()
      return /^[-+]?\d+(?:[.,]\d+)?$/.test(normalizedQuantity) ? `${normalizedQuantity}x` : normalizedQuantity
    },
    getRandomInt (max) {
      return Math.floor(Math.random() * max)
    },
    deleteEntry (entry) {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss">
.repeater-drop-zone:first-child button[title="Remove block"]{
  display: none !important;
}

.repeater-drop-zone button[content="Duplicate"]{
  display: none !important;
}

.qty-suggestions-row {
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(120px, max-content));
  justify-content: start;
}

.qty-suggestion-button {
  border-radius: 999px;
  font-size: 0.95rem;
  min-height: 2.5rem;
  padding: 0.45rem 0.9rem;
}

@media (max-width: 767.98px) {
  .qty-suggestions-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .qty-suggestion-button {
    min-height: 2.75rem;
    width: 100%;
  }
}
</style>
